export default {
  controlinetpays: {
    title: "Контроль за поступлением интернет-платежей",
    displayPayment: {
      title: "Отображать оплаты",
      payAll: "Все",
      payMoneyReceived: "По которым поступили деньги",
      payMoneyNotReceived: "По которым не поступили деньги",
      payPersonalAccounts: "Отображать оплаты по лицевым счетам"
    },
    reportingMonthColumn: {
      headers: {
        reportingMonth: "Отчетный месяц"
      }
    },
    paymentSenderColumn: {
      headers: {
        paymentSender: "Отправитель платежа"
      }
    },
    inetPayNotConnectedPaymentsColumn: {
      headers: {
        inetPayNotConnectedPayments: "Интернет-оплаты, не связанные с платежами"
      }
    },
    personalAccountsPaymentsColumn: {
      headers: {
        abcodeLong: "Лицевой счет",
        payment: "Оплата",
        registry: "Реестр"
      }
    },
    moveToNextMonth: {
      confirm: {
        transferPaymentsFrom: "Перенести оплаты от",
        for: "за",
        on: "на",
        title: "Перенос на следующий месяц"
      }
    },
    cancelReceivedRegistry: {
      confirm: {
        сancelRegistry: "Отменить реестр",
        from: "от",
        behind: "за",
        title: "Отмена полученного реестра"
      }
    },
    cancelSubscriberPayment: {
      confirm: {
        сancelSubscriberPayment: "Отменить оплату абонента",
        behind: "за",
        on: "на",
        title: "Отмена оплаты абонента"
      }
    }
  }
};
